import { render, staticRenderFns } from "./AppTableLimit.vue?vue&type=template&id=22bd7562&scoped=true&"
import script from "./AppTableLimit.vue?vue&type=script&lang=js&"
export * from "./AppTableLimit.vue?vue&type=script&lang=js&"
import style0 from "./AppTableLimit.vue?vue&type=style&index=0&id=22bd7562&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bd7562",
  null
  
)

export default component.exports